module.exports = __webpack_public_path__ + "img/hohlsaum_beige_ohneral.ef88df40.jpg";